import { createClient, type SupabaseClient } from '@supabase/supabase-js';

// Lazily-created singleton. URL + anon key come from VITE_ env (public by
// design, RLS-gated). The default storage key stays `sb-<ref>-auth-token`,
// derived from the URL — do NOT override it, or the screenshots/e2e session
// injection harness breaks.
let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (!client) {
    const url = import.meta.env.VITE_SUPABASE_URL;
    const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
    if (!url || !key) return null;
    try {
      client = createClient(url, key);
    } catch {
      return null;
    }
  }
  return client;
}
